"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keysOf = exports.isArray = void 0;
function isArray(arr) {
    return Array.isArray(arr);
}
exports.isArray = isArray;
function keysOf(object) {
    return Object.keys(object);
}
exports.keysOf = keysOf;
//# sourceMappingURL=index.js.map